// https://dev.to/ankitprajapati/exporting-data-to-excel-file-in-angular-using-exceljs-k13
import { Injectable } from '@angular/core';
import * as fs from 'file-saver';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
@Injectable({
  providedIn: 'root'
})
export class ExcelService {

  constructor() { }

  generateExcel(data: any[]) {
    if (!data || data.length === 0) return;
  
    const rows = data.map(user => ({
      'First Name'       : user.firstName || "--",
      'Last Name'        : user.lastName || "--",
      'Email'            : user.email || "--",
      'Phone'            : user.phone || "--",
      'Address'          : (user.addresses && user.addresses.length > 0)
                             ? user.addresses[0].addressLine : "--",
      'No. of Bookings'  : user.bookingData ? user.bookingData.totalBookings : 0,
      'Registration Date': user.creationDate
                             ? new Date(user.creationDate).toLocaleString() : "--",
      'Last Booking Date': (user.bookingData && user.bookingData.lastBookingDate)
                             ? new Date(user.bookingData.lastBookingDate + 'T00:00:00').toLocaleDateString() : "--",
      'Status'           : user.status || "--"
    }));
  
    const worksheet = XLSX.utils.json_to_sheet(rows);
  
    // Set column widths
    worksheet['!cols'] = [
      { wch: 15 }, { wch: 15 }, { wch: 25 }, { wch: 15 },
      { wch: 35 }, { wch: 15 }, { wch: 22 }, { wch: 22 }, { wch: 10 }
    ];
  
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'User Analytics');
  
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
  
    saveAs(blob, `UserAnalytics_${new Date().getTime()}.xlsx`);
  }

  async generateDemoFile() {
    const title = 'Car Sell Report';
    const header = ["Year", "Month", "Make", "Model", "Quantity", "Pct"]
    const data = [
      [2007, 1, "Volkswagen ", "Volkswagen Passat", 1267, 10],
      [2007, 1, "Toyota ", "Toyota Rav4", 819, 6.5],
      [2007, 1, "Toyota ", "Toyota Avensis", 787, 6.2],
      [2007, 1, "Volkswagen ", "Volkswagen Golf", 720, 5.7],
      [2007, 1, "Toyota ", "Toyota Corolla", 691, 5.4],
    ];

    // Lazy-load exceljs to avoid side effects during app bootstrap.
    const { Workbook } = await import('exceljs');
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet('Car Data');
    let worksheet2 = workbook.addWorksheet('Scooter Data');

    // Add new row
    let titleRow = worksheet.addRow([title], '');
    let titleRow2 = worksheet2.addRow(['Scooter Sell Report'], '');

    // Set font, size and style in title row.
    titleRow.font = { name: 'Comic Sans MS', family: 4, size: 16, underline: 'double', bold: true };
    titleRow2.font = { name: 'Comic Sans MS', family: 4, size: 16, underline: 'double', bold: true };

    // Blank Row
    worksheet.addRow([], '');

    worksheet.addRow(header, '');
    data.forEach(d => {
      let row = worksheet.addRow(d, '');
      let qty = row.getCell(5);
      let color = 'FF99FF99';
      if (+qty.value < 500) {
        color = 'FF9999'
      }
      qty.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: color }
      }
    });

    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'CarData.xlsx');
    });
  }
}
